import banks from '@/data/partner/bank.json'
export default () => {
  const { $t } = useNuxtApp()

  const listBankAccounts = () => {
    const value = banks.map((item) => {
      return {
        key: item.key,
        name: `${$t(item.name)} (${item.key})`,
        type: item.type
      }
    })

    const banksTMCP = value.filter((item) => item.type === 'TMCP').sort((a, b) => a.name.localeCompare(b.name))
    const banksOrder = value.filter((item) => item.type !== 'TMCP').sort((a, b) => a.name.localeCompare(b.name))

    return [...banksTMCP, ...banksOrder]
  }

  return {
    listBankAccounts
  }
}
